import { defineComponent as _defineComponent } from 'vue'
import { computed, unref } from 'vue';
import { useI18n } from 'nuxt-i18n-composable';
import appleEnglish from './assets/apple/en-GB-add-to-apple-wallet.svg';
import appleGerman from './assets/apple/de-DE-add-to-apple-wallet.svg';
import appleSpanish from './assets/apple/es-ES-add-to-apple-wallet.svg';
import appleFrench from './assets/apple/fr-FR-add-to-apple-wallet.svg';
import appleItalian from './assets/apple/it-IT-add-to-apple-wallet.svg';
import appleDutch from './assets/apple/nl-NL-add-to-apple-wallet.svg';
import applePolish from './assets/apple/pl-PL-add-to-apple-wallet.svg';
import applePortugueseEu from './assets/apple/pt-PT-add-to-apple-wallet.svg';

import googleEnglish from './assets/google/en-GB-add-to-google-wallet.svg';
import googleGerman from './assets/google/de-DE-add-to-google-wallet.svg';
import googleSpanish from './assets/google/es-ES-add-to-google-wallet.svg';
import googleFrench from './assets/google/fr-FR-add-to-google-wallet.svg';
import googleItalian from './assets/google/it-IT-add-to-google-wallet.svg';
import googleDutch from './assets/google/nl-NL-add-to-google-wallet.svg';
import googlePolish from './assets/google/pl-PL-add-to-google-wallet.svg';
import googlePortugueseEu from './assets/google/pt-PT-add-to-google-wallet.svg';

type Language =
  | 'english'
  | 'german'
  | 'spanish'
  | 'french'
  | 'italian'
  | 'dutch'
  | 'polish'
  | 'portugueseEu';

type VariantAssets = {
  [key: string]: {
    [key in Language]: string;
  };
};

type WalletVariant = 'apple' | 'google';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-to-smart-wallet-button',
  props: {
    ticketDownloadLink: null,
    variant: null
  },
  setup(__props: any) {

const props = __props as {
  ticketDownloadLink: string;
  variant: WalletVariant;
};

const variantAssets: VariantAssets = {
  apple: {
    english: appleEnglish,
    german: appleGerman,
    spanish: appleSpanish,
    french: appleFrench,
    italian: appleItalian,
    dutch: appleDutch,
    polish: applePolish,
    portugueseEu: applePortugueseEu,
  },
  google: {
    english: googleEnglish,
    german: googleGerman,
    spanish: googleSpanish,
    french: googleFrench,
    italian: googleItalian,
    dutch: googleDutch,
    polish: googlePolish,
    portugueseEu: googlePortugueseEu,
  },
};



const { locale } = useI18n();

const svgSource = computed((): string => {
  const assetsByPlatform = variantAssets[props.variant];
  const currentLocale = unref(locale);
  switch (currentLocale) {
    case 'de-DE':
      return assetsByPlatform.german;
    case 'es-ES':
      return assetsByPlatform.spanish;
    case 'fr-FR':
      return assetsByPlatform.french;
    case 'it-IT':
      return assetsByPlatform.italian;
    case 'nl-NL':
      return assetsByPlatform.dutch;
    case 'pl-PL':
      return assetsByPlatform.polish;
    case 'pt-PT':
      return assetsByPlatform.portugueseEu;
    default:
      return assetsByPlatform.english;
  }
});

const walletLink = computed((): string => {
  return `${props.ticketDownloadLink}&type=${props.variant}wallet`;
});

const altTagText = computed((): string => {
  return `Button showing the add to ${props.variant} wallet logo`;
});

return { __sfc: true,variantAssets, props, locale, svgSource, walletLink, altTagText }
}

})